/** Root frame for every route: skip link, offline banner, scroll restoration, outlet. */
import { Outlet, ScrollRestoration } from 'react-router';
import { OfflineBanner } from '../components/OfflineBanner';
import { SkipLink } from '../components/SkipLink';

export function RootLayout() {
  return (
    <>
      <SkipLink />
      <OfflineBanner />
      <Outlet />
      <ScrollRestoration />
    </>
  );
}
